import { useMediaQuery } from "react-responsive"
import { preload } from "react-dom"

const ImageTitleItem = (props) => {

    const { imageURL, imageURLMobile, titleText, icon, subtitleText, overImageURL, bottom } = props

    const isMobile = useMediaQuery({ maxWidth: 1280 })

    preload(isMobile ? (imageURLMobile || imageURL) : imageURL, { as: "image", fetchPriority: "high" })

    if (isMobile)
        return (
            <section className="administration-section">
                <img fetchPriority="high" alt="Imagen" src={imageURLMobile || imageURL} className="publish-image"></img>
                {/* <h2 className="slider-text static">{titleText}</h2> */}
                <section className={bottom ? "press-floating-text btm-30vh" : "press-floating-text"}>
                    <h2 className="blue-h2">{titleText}</h2>
                    <article className="flex acenter gap-10">
                        <p>{subtitleText}</p>
                    </article>
                </section>
                {
                    (overImageURL) ? <img alt="Imagen" src={overImageURL} className="over-img"></img> : <></>
                }
            </section>
        )
    else
        return (
            <section className="administration-section">
                <img fetchPriority="high" alt="Imagen" src={imageURL} className="publish-image"></img>
                {/* <h2 className="slider-text static">{titleText}</h2> */}
                <section className={bottom ? "press-floating-text btm-30vh" : "press-floating-text"}>
                    <h2 className="blue-h2">{titleText}</h2>
                    <article className="flex acenter gap-10">
                        <i className={icon}></i>
                        <p>{subtitleText}</p>
                    </article>
                </section>
                {
                    (overImageURL) ? <img alt="Imagen" src={overImageURL} className="over-img"></img> : <></>
                }
            </section>
        )


}

export default ImageTitleItem